import React from 'react';
import TopBar from '../components/site/TopBar';
import Header from '../components/site/Header';
import Hero from '../components/site/Hero';
import About from '../components/site/About';
import Pillars from '../components/site/Pillars';
import Stats from '../components/site/Stats';
import Formula from '../components/site/Formula';
import BookSection from '../components/site/BookSection';
import Achievements from '../components/site/Achievements';
import Testimonials from '../components/site/Testimonials';
import FinalCTA from '../components/site/FinalCTA';
import Footer from '../components/site/Footer';

export default function HomePage() {
  return (
    <>
      <TopBar />
      <Header />
      <main>
        <Hero />
        <About />
        <Pillars />
        <Stats />
        <Formula />
        <BookSection />
        <Achievements />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </>
  );
}
